export function initAccordionPrintHandler() {

  const accordionElements = document.querySelectorAll('.js-accordion');

  addEventListener('beforeprint', (event) => {
    accordionElements.forEach((accordionElement) => {
      accordionElement.toggleAttribute('open');
    });
  });
}
